import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useCloseInquiry from './hooks/useCloseInquiry';

interface Params {
    inquiryId: string;
}

const CloseInquiryModal:ActivityComponentType<Params> = ({ params }: {params: Params}) => {
  const { inquiryId } = params;
  const { pop } = useFlow();
  const closeInquiry = useCloseInquiry(inquiryId);
  return (
      <Modal>
          <ModalContainer>
              <Column fullWidth spacing={42} align='center'>
                  <Column spacing={8} align='center'>
                      <Text fontWeight='bold' size='2xl'>
                          문의를 종료하시겠습니까?
                      </Text>
                      <Text color={colors.gray6}>
                          문의 내용은 내역에서 확인하실 수 있습니다.
                      </Text>
                  </Column>
                  <Row fullWidth spacing={10}>
                      <Button fullWidth onClick={pop} variant='secondary' noPadding>
                          취소
                      </Button>
                      <Button fullWidth onClick={closeInquiry} noPadding>
                          종료
                      </Button>
                  </Row>
              </Column>
          </ModalContainer>
      </Modal>
  );
};

export default CloseInquiryModal;
